import React from "react";
import { PersonTag } from "./PersonTag.js";
import "./PersonTag.css";

import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  DotGroup
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";

export const PersonTagCarousel = (props) => {
      const {personItems, isGrid} = props;
      console.log(personItems)
      
      //Custom Carousel Slider
      let visibleSlides, slideSize;

      if (isGrid) {
        visibleSlides = 4;
        slideSize = {
          width: "calc(0.67*30vw)",
          height: "calc(30vw)",
        };
      } else {
        visibleSlides = 3;
        slideSize = {
          width: "20vw",
          height: "calc(0.75*20vw)",
        };
      }
    return (
      <CarouselProvider
        className="person_tag carousel_container"
        naturalSlideWidth={slideSize.width}
        naturalSlideHeight={slideSize.height}
        totalSlides={personItems.length}
        isIntrinsicHeight={true}
        touchEnabled={true}
        visibleSlides={visibleSlides}
        dragEnabled={true}
        dragStep={1}
      >
        <Slider moveThreshold={0.1}>
          {personItems.map((item, index) => (
            <Slide index={index}>
              <PersonTag personData={item} />
            </Slide>
          ))}
        </Slider>
        <div>
          <DotGroup disableActiveDots={false}/>
        </div>
      </CarouselProvider>
    );
}